<template>
  <div class="container col-sm-8 center">
    <h1 class="text-center">About <strong>sipr Project</strong></h1>
    <h2>Initial Goal</h2>
    <p class="text-center">Develop a software tool to help scholars identify
      Akkadian and Aramaic cognates for words in the Hebrew Bible.</p>
    <p>The tool is based on the unvocalized Westminster Leningrad Codex
      transcription of this Hebrew Text, and the CAL and EBL Projects, in order
      to help them determine the meaning of doubtful words, especially hapax
      legomena, and obscure passages, so they can keep improving current
      modern translations of the Biblical Text.</p>
    <h2>Current State of Development</h2>
    2026.03.25
    <ul>
      <li>Hebrew text transliteration implemented</li>
      <li>Akkadian cognate candidates search implemented</li>
      <li>Aramaic cognate candidates search implemented</li>
      <li>Hebrew root strip algorithm under development</li>
      <li>User interface under development</li>
    </ul>
    <br />
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  name: 'AboutView',
  props: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  text-align: center;
  margin-top: 2em;
  margin-bottom: 1em;
}
</style>
